// Beweging die een script nodig heeft (DESIGN.md §7, Rick 26 sep 2026). Twee dingen:
//
// 1. Uitklappen (.uitklap, .adresklap) groeien en krimpen zoals de zoeklade, op haar curve:
//    de hoogte in --dur-lade, de inhoud fadet 200ms en valt 6px in, 80ms later. Dicht gaat
//    sneller (70%) en de inhoud fadet direct weg. Een klik tijdens de beweging draait hem om
//    vanaf waar hij is. De "+" draait mee in CSS (data-klap).
// 2. De reizende foto: de productkaart waarop geklikt wordt krijgt .reist; theme.css geeft
//    zijn foto dan dezelfde view-transition-name als de eerste foto op de shaftpagina.
//
// Zonder dit script klappen de <details> gewoon open en dicht en wisselen pagina's zonder
// reizende foto. Onder prefers-reduced-motion klappen ze zonder beweging.

const rustig = matchMedia('(prefers-reduced-motion: reduce)');
const token = (naam) => getComputedStyle(document.documentElement).getPropertyValue(naam).trim();
// Een duurtoken in ms. Shopify's CSS-minifier schrijft `340ms` als `.34s`, dus de eenheid telt.
const duurVan = (naam) => { const w = token(naam); return parseFloat(w) * (w.endsWith('ms') ? 1 : 1000); };
const loopt = new WeakMap(); // details → zijn lopende animaties

function klap(details, open) {
  const kop = details.querySelector(':scope > summary');
  const inhoud = [...details.children].filter((el) => el !== kop);
  const wasDicht = !details.open;
  // Eerst meten, dan pas afbreken: zo begint een omkering op de hoogte en dekking van nu.
  const van = details.getBoundingClientRect().height;
  const dekking = inhoud.map((el) => (wasDicht ? 0 : Number(getComputedStyle(el).opacity)));
  loopt.get(details)?.forEach((a) => a.cancel());

  details.open = true; // ook bij dichtgaan: de inhoud blijft staan tot de hoogte er is
  const stijl = getComputedStyle(details);
  const rand = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom']
    .reduce((som, eigenschap) => som + parseFloat(stijl[eigenschap]), 0);
  const naar = open ? details.getBoundingClientRect().height : kop.getBoundingClientRect().height + rand;
  const duur = duurVan('--dur-lade') * (open ? 1 : 0.7);
  const curve = token('--ease-lade');

  details.dataset.klap = open ? 'open' : 'dicht';
  details.style.overflow = 'clip';
  const animaties = [details.animate({ height: [`${van}px`, `${naar}px`] }, { duration: duur, easing: curve })];
  inhoud.forEach((el, i) => {
    if (open) {
      const later = wasDicht ? 80 : 0;
      animaties.push(el.animate({ opacity: [dekking[i], 1] }, { duration: 200, delay: later, easing: 'ease-out', fill: 'backwards' }));
      if (wasDicht) animaties.push(el.animate({ translate: ['0 -6px', '0 0'] }, { duration: duur, delay: later, easing: curve, fill: 'backwards' }));
    } else {
      animaties.push(el.animate({ opacity: [dekking[i], 0] }, { duration: duurVan('--dur-state'), easing: 'ease-out', fill: 'forwards' }));
    }
  });
  loopt.set(details, animaties);

  // Een afgebroken animatie verwerpt: dan neemt de volgende klik het over.
  Promise.all(animaties.map((a) => a.finished)).then(() => {
    if (!open) details.open = false;
    animaties.forEach((a) => a.cancel());
    details.style.overflow = '';
    delete details.dataset.klap;
    loopt.delete(details);
  }, () => {});
}

// Eén luisteraar voor de hele pagina: ook uitklappen die de theme editor later tekent doen mee.
// Enter en spatie op een <summary> komen hier ook binnen, als klik.
document.addEventListener('click', (e) => {
  const kop = e.target.closest?.('summary');
  const details = kop?.parentElement;
  if (rustig.matches || !details?.matches('.uitklap, .adresklap') || kop !== details.querySelector(':scope > summary')) return;
  e.preventDefault();
  klap(details, !details.open || details.dataset.klap === 'dicht');
});

// De reizende foto: alleen de aangeklikte kaart, zodat de naam uniek blijft (een tweede kaart
// van dezelfde shaft in de zoeklade zou de overgang anders laten vervallen). Met een
// modifier opent de link elders; dan reist er niets.
document.addEventListener('click', (e) => {
  const kaart = e.target.closest?.('a.product');
  if (!kaart || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  document.querySelectorAll('.product.reist').forEach((el) => el.classList.remove('reist'));
  kaart.classList.add('reist');
});
